import { Button, DatePicker, Input, message, Modal, Spin, Table } from "antd";
import React, { useContext, useEffect, useMemo, useState } from "react";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { ReactComponent as TrashDelete } from "assets/Trash_Full.svg";
import { RightOutlined } from "@ant-design/icons";
import { StyledTable } from "atoms/Table";
import {
  ButtonFilled,
  ButtonLink,
  ButtonOutlined,
} from "reusableComponent/UIButtons";
import { connect, useSelector } from "react-redux";
import {
  getLoadNewDataList,
  getLocations,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { object } from "prop-types";
import { options } from "less";
import { CALL_API } from "common/API";
import dayjs from "dayjs";
import { STATUS_CODE } from "common/Constants";
import moment from "moment";
import axios from "axios";
import { EmployeeInfo } from "./EmployeeInfo";
import user from "../../../src/assets/employeeinfo.svg";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { setLoadNewDataList } from "redux/actions";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { ContainerContext } from "pages/Container";
dayjs.extend(weekday);

dayjs.extend(localeData);

const StyledDiv = styled.div`
  .wrapped-header {
    white-space: normal !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }

  .Appraisal_first_tabledata {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    
  }
     .ant-layout-content{
    padding-bottom: 100px !important;
    }
`;
const StyledForm = styled.div`
  .ant-table-wrapper {
    padding-bottom:100px !important;
  }
`;

const CreateEditPerformance = ({
  setIsAddEdit,
  selectedUserRecord,
  isbreadcrum,
  userList,
  setLoadNewData,
  loadNewDataList,
}) => {
  const { layoutContentRef } = useContext(ContainerContext);
  const locationList = useSelector((state) => getLocations(state)) || [];
  const userInfo = useSelector((state) => getUserInfo(state)) || {};
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submitType, setSubmitType] = useState("normal");

  const showModal = () => setIsModalVisible(true);

  const handleCancelModal = () => setIsModalVisible(false);

  const selectedEmployee = userList?.find(
    (item) => item?.userid === selectedUserRecord?.userid
  );

  // const [data, setData] = useState(selectedUserRecord);
  const [data, setData] = useState({
    ...selectedUserRecord,
    attendstartdate: dayjs(selectedUserRecord?.attendstartdate).isValid()
      ? dayjs(selectedUserRecord?.attendstartdate)
      : null,
    attendenddate: dayjs(selectedUserRecord?.attendenddate).isValid()
      ? dayjs(selectedUserRecord?.attendenddate)
      : null,
    period: selectedUserRecord?.period || "Half Yearly Appraisal"
  });

  const [loader, setLoader] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    strategic: [],
    previous: [],
    upcoming: [],
    bdo: [],
  });
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const handleSelectChange = (selectedItems, type) => {
    setData((prev) => ({
      ...prev,
      [type]: selectedItems,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only update specific fields while preserving other state values
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBdoValueChange = (index, field, value) => {
    const updated = bdoValues.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );
    setBdoValues(updated);
    validateTotalWeightage(updated);

    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.bdo.includes(index)) {
        if (value) {
          updated.bdo = updated.bdo.filter((i) => i !== index);
        }
      }
      return updated;
    });
  };

  const [weightageError, setWeightageError] = useState("");
  const [isEditBdoValues, setIsEditBdoValues] = useState(false);

  const validateTotalWeightage = (updatedValues) => {
    const total = updatedValues.reduce(
      (sum, item) => sum + (parseInt(item?.weightage, 10) || 0),
      0
    );

    if (total !== 100) {
      setWeightageError("Total weightage must be exactly 100");
    } else {
      setWeightageError("");
    }
  };

  const dataColumns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text, record, index) =>
        !isEditBdoValues ? (
          <>{text}</>
        ) : (
          <Input
            placeholder="Enter weightage"
            value={record?.weightage}
            style={{
              border:
                invalidFields.bdo.includes(index) && !record.weightage
                  ? "1px solid red"
                  : "",
            }}
            status={
              invalidFields.bdo.includes(index) && !record.weightage
                ? "error"
                : ""
            }
            onKeyDown={(event) => {
              if (
                !/[0-9]/.test(event.key) &&
                event.key !== "Backspace" &&
                event.key !== "Tab"
              ) {
                event.preventDefault();
              }
            }}
            onChange={(e) =>
              handleBdoValueChange(index, "weightage", e.target.value)
            }
          />
        ),
    },
  ];
  const [weightageStrategicError, setWeightageStrategicError] = useState("");

  const handleStrategicObjectivesChange = (index, field, value) => {
    const updated = strategicObjectivesData.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );
    setStrategicObjectivesData(updated);

    if (field === "weightage") {
      const total = updated.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );

      setWeightageStrategicError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.strategic.includes(index)) {
        // Check if the new value is not empty, then remove index from invalids
        if (value) {
          updated.strategic = updated.strategic.filter((i) => i !== index);
        }
      }
      return updated;
    });
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: (
        <div style={{ whiteSpace: "wrap" }}>
          Strategic Objectives aligned to Organisational Strategy for the
          upcoming appraisal period
        </div>
      ),
      dataIndex: "strategicObjectives",
      key: "strategicObjectives",
      width: "30%",
      render: (text, record, index) => (
        <>
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 6 }}
            placeholder="Enter objectives..."
            value={record?.strategicObjectives}
            style={{
              width: "100%",
              border:
                invalidFields.strategic.includes(index) &&
                  !record.strategicObjectives
                  ? "1px solid red"
                  : "",
            }}
            status={
              invalidFields.strategic.includes(index) &&
                !record.strategicObjectives
                ? "error"
                : ""
            }
            onChange={(e) =>
              handleStrategicObjectivesChange(
                index,
                "strategicObjectives",
                e.target.value
              )
            }
          />
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      width: "30%",
      render: (text, record, index) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          placeholder="Enter expected outcomes..."
          value={record?.expectedOutcomes}
          style={{
            width: "100%",
            border:
              invalidFields.strategic.includes(index) &&
                !record.expectedOutcomes
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.strategic.includes(index) && !record.expectedOutcomes
              ? "error"
              : ""
          }
          onChange={(e) =>
            handleStrategicObjectivesChange(
              index,
              "expectedOutcomes",
              e.target.value
            )
          }
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      width: "20%",
      render: (text, record, index) => (
        <DatePicker
          format={"DD-MM-YYYY"}
          placeholder="Enter target date..."
          value={record?.targetDate}
          style={{
            width: "100%",
            border:
              invalidFields.strategic.includes(index) && !record.targetDate
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.strategic.includes(index) && !record.targetDate
              ? "error"
              : ""
          }
          onChange={(date) =>
            handleStrategicObjectivesChange(index, "targetDate", date)
          }
        />
      ),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      render: (text, record, index) => (
        <Input
          placeholder="Enter weightage"
          value={record?.weightage}
          style={{
            border:
              invalidFields.strategic.includes(index) && !record.weightage
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.strategic.includes(index) && !record.weightage
              ? "error"
              : ""
          }
          onKeyDown={(event) => {
            if (
              !/[0-9]/.test(event.key) &&
              event.key !== "Backspace" &&
              event.key !== "Tab"
            ) {
              event.preventDefault();
            }
          }}
          onChange={(e) =>
            handleStrategicObjectivesChange(index, "weightage", e.target.value)
          }
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button disabled={strategicObjectivesData?.length === 1}>
          <TrashDelete
            disabled={strategicObjectivesData?.length === 1}
            onClick={() => handleDeleteRow(record.id)}
          >
            Delete
          </TrashDelete>
        </Button>
      ),
    },
  ];

  const [weightageUpcomingError, setWeightageUpcomingError] = useState("");

  const handleUpcomingChange = (index, field, value) => {
    const updated = upcomingData.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );

    setUpcomingData(updated);

    if (field === "weightage") {
      const total = updated.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );
      setWeightageUpcomingError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.upcoming.includes(index)) {
        if (value) {
          updated.upcoming = updated.upcoming.filter((i) => i !== index);
        }
      }
      return updated;
    });
  };

  const UpcomingAppraisalcolumns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: (
        <div style={{ whiteSpace: "wrap" }}>
          Target objectives aligned to Organizational Strategy for the upcoming
          appraisal period
        </div>
      ),
      dataIndex: "previousObjectives",
      key: "previousObjectives",
      width: "30%",
      render: (text, record, index) => (
        <>
          <Input.TextArea
            placeholder="Enter objectives..."
            value={record?.previousObjectives}
            autoSize={{ minRows: 1, maxRows: 6 }}
            style={{
              border:
                invalidFields.upcoming.includes(index) &&
                  !record.previousObjectives
                  ? "1px solid red"
                  : "",
              width: "100%",
            }}
            status={
              invalidFields.upcoming.includes(index) &&
                !record.previousObjectives
                ? "error"
                : ""
            }
            onChange={(e) =>
              handleUpcomingChange(index, "previousObjectives", e.target.value)
            }
          />
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      width: "30%",
      render: (text, record, index) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          placeholder="Enter expected outcomes..."
          value={record?.expectedOutcomes}
          style={{
            width: "100%",
            border:
              invalidFields.upcoming.includes(index) && !record.expectedOutcomes
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.upcoming.includes(index) && !record.expectedOutcomes
              ? "error"
              : ""
          }
          onChange={(e) =>
            handleUpcomingChange(index, "expectedOutcomes", e.target.value)
          }
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      width: "20%",
      render: (text, record, index) => (
        <DatePicker
          format={"DD-MM-YYYY"}
          placeholder="Enter target date..."
          value={record?.targetDate}
          style={{
            width: "100%",
            border:
              invalidFields.upcoming.includes(index) && !record.targetDate
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.upcoming.includes(index) && !record.targetDate
              ? "error"
              : ""
          }
          onChange={(date) => handleUpcomingChange(index, "targetDate", date)}
        />
      ),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      render: (text, record, index) => (
        <Input
          placeholder="weightage"
          value={record?.weightage}
          style={{
            border:
              invalidFields.upcoming.includes(index) && !record.weightage
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.upcoming.includes(index) && !record.weightage
              ? "error"
              : ""
          }
          onKeyDown={(event) => {
            if (
              !/[0-9]/.test(event.key) &&
              event.key !== "Backspace" &&
              event.key !== "Tab"
            ) {
              event.preventDefault();
            }
          }}
          onChange={(e) =>
            handleUpcomingChange(index, "weightage", e.target.value)
          }
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button disabled={upcomingData?.length === 1}>
          <TrashDelete
            disabled={upcomingData?.length === 1}
            onClick={() => upcomingAppraisalDeleteRow(record.id)}
          >
            Delete
          </TrashDelete>
        </Button>
      ),
    },
  ];

  const [weightagePreviousError, setWeightagePreviousError] = useState("");

  const handlePreviousChange = (index, field, value) => {
    const updated = previousObjectivesData.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );

    setPreviousObjectivesData(updated);

    if (field === "weightage") {
      const total = updated.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );
      setWeightagePreviousError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.previous.includes(index)) {
        if (value) {
          updated.previous = updated.previous.filter((i) => i !== index);
        }
      }
      return updated;
    });
  };

  const previousAppraisalcolumns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: "Objectives that Rolled Over from Previous Appraisal Period",
      dataIndex: "previousObjectives",
      key: "previousObjectives",
      width: "30%",
      render: (text, record, index) => (
        <>
          <Input.TextArea
            placeholder="Enter objectives..."
            autoSize={{ minRows: 1, maxRows: 6 }}
            value={record?.previousObjectives}
            style={{
              width: "100%",
              border:
                invalidFields.previous.includes(index) &&
                  !record.previousObjectives
                  ? "1px solid red"
                  : "",
            }}
            status={
              invalidFields.previous.includes(index) &&
                !record.previousObjectives
                ? "error"
                : ""
            }
            onChange={(e) =>
              handlePreviousChange(index, "previousObjectives", e.target.value)
            }
          />
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      width: "30%",
      render: (text, record, index) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          placeholder="Enter expected outcomes..."
          value={record?.expectedOutcomes}
          style={{
            width: "100%",
            border:
              invalidFields.previous.includes(index) && !record.expectedOutcomes
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.previous.includes(index) && !record.expectedOutcomes
              ? "error"
              : ""
          }
          onChange={(e) =>
            handlePreviousChange(index, "expectedOutcomes", e.target.value)
          }
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      width: "20%",
      render: (text, record, index) => (
        <DatePicker
          format={"DD-MM-YYYY"}
          placeholder="Enter target date..."
          value={record?.targetDate}
          style={{
            width: "100%",
            border:
              invalidFields.previous.includes(index) && !record.targetDate
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.previous.includes(index) && !record.targetDate
              ? "error"
              : ""
          }
          onChange={(date) => handlePreviousChange(index, "targetDate", date)}
        />
      ),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      render: (text, record, index) => (
        <Input
          placeholder="Enter weightage"
          value={record?.weightage}
          style={{
            border:
              invalidFields.previous.includes(index) && !record.weightage
                ? "1px solid red"
                : "",
          }}
          status={
            invalidFields.previous.includes(index) && !record.weightage
              ? "error"
              : ""
          }
          onChange={(e) =>
            handlePreviousChange(index, "weightage", e.target.value)
          }
          onKeyDown={(event) => {
            if (
              !/[0-9]/.test(event.key) &&
              event.key !== "Backspace" &&
              event.key !== "Tab"
            ) {
              event.preventDefault();
            }
          }}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button disabled={false}>
          <TrashDelete onClick={() => PreviousAppraisalDeleteRow(record.id)}>
            disabled=
            {false}
            Delete
          </TrashDelete>
        </Button>
      ),
    },
  ];

  // Initial data for strategic objectives table

  const strategicObjectivesdataSource = [
    {
      id: 1,
      strategicObjectives: "",
      expectedOutcomes: "",
      targetDate: "",
      weightage: "",
    },
  ];

  const [strategicObjectivesData, setStrategicObjectivesData] = useState(
    selectedUserRecord?.startegicobjectives?.length > 0
      ? selectedUserRecord?.startegicobjectives.map((row, idx) => ({
        id: idx + 1,
        strategicObjectives: row.straobjorgstartegy,
        expectedOutcomes: row.expectedoutcome,
        targetDate: row?.TargetDate ? dayjs(row?.TargetDate) : "",
        weightage: String(row.Weightage),
      }))
      : strategicObjectivesdataSource
  );

  const totalWeightage = strategicObjectivesData.reduce((total, row) => {
    const weight = parseFloat(row.weightage);
    return total + (isNaN(weight) ? 0 : weight);
  }, 0);

  const isWeightageInvalid = totalWeightage !== 100;

  const handleAddRow = () => {
    if (strategicObjectivesData.length >= 10) {
      message.warning("You can only add up to 10 rows.");
      return;
    }

    const newRow = {
      id: strategicObjectivesData.length + 1,
      strategicObjectives: "",
      expectedOutcomes: "",
      targetDate: null,
      weightage: "",
    };

    setStrategicObjectivesData([...strategicObjectivesData, newRow]);
  };

  const handleDeleteRow = (id) => {
    const filteredData = strategicObjectivesData.filter(
      (item) => item.id !== id
    );

    const updatedData = filteredData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    setStrategicObjectivesData(updatedData);
  };

  //previous apprisal

  const previousObjectivesdataSource = [
    {
      id: 1,
      previousObjectives: "",
      expectedOutcomes: "",
      targetDate: "",
      weightage: "",
    },
  ];

  const [previousObjectivesData, setPreviousObjectivesData] = useState(
    selectedUserRecord?.rolloverresponsibility?.length > 0
      ? selectedUserRecord?.rolloverresponsibility.map((row, idx) => ({
        id: idx + 1,
        previousObjectives: row.previousappraisalperiod,
        expectedOutcomes: row.expectedoutcome,
        targetDate: row?.TargetDate ? dayjs(row?.TargetDate) : "",
        weightage: String(row.Weightage),
      }))
      : []
  );

  const PreviousAppraisalAddRow = () => {
    if (previousObjectivesData.length >= 10) {
      message.warning("You can only add up to 10 rows.");
      return;
    }

    const newRow = {
      id: previousObjectivesData.length + 1,
      previousObjectives: "",
      expectedOutcomes: "",
      targetDate: null,
      weightage: "",
    };

    setPreviousObjectivesData([...previousObjectivesData, newRow]);
  };

  const PreviousAppraisalDeleteRow = (id) => {
    const filteredData = previousObjectivesData.filter(
      (item) => item.id !== id
    );

    const updatedData = filteredData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    setPreviousObjectivesData(updatedData);
  };

  //upcoming apprasal

  const upcomingdataSource = [
    {
      id: 1,
      previousObjectives: "",
      expectedOutcomes: "",
      targetDate: "",
      weightage: "",
    },
  ];

  const [upcomingData, setUpcomingData] = useState(
    selectedUserRecord?.upcomingappraisalperiod?.length > 0
      ? selectedUserRecord?.upcomingappraisalperiod.map((row, idx) => ({
        id: idx + 1,
        previousObjectives: row?.upcomingappraisalperiod,
        expectedOutcomes: row?.expectedoutcome,
        targetDate: row?.TargetDate ? dayjs(row?.TargetDate) : "",
        weightage: String(row?.Weightage),
      }))
      : upcomingdataSource
  );

  const upcomingAppraisalAddRow = () => {
    if (upcomingData.length >= 5) {
      message.warning("You can only add up to 5 rows.");
      return;
    }

    const newRow = {
      id: upcomingData.length + 1,
      previousObjectives: "",
      expectedOutcomes: "",
      targetDate: null,
      weightage: "",
    };

    setUpcomingData([...upcomingData, newRow]);
  };

  const upcomingAppraisalDeleteRow = (id) => {
    const filteredData = upcomingData?.filter((item) => item.id !== id);

    const updatedData = filteredData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    setUpcomingData(updatedData);
  };

  //Individual (soft skills) Assessment / BDO VALUES

  const BDOValues = [
    {
      id: 1,
      objectives: "Integrity, Honesty (Trusted)",
      weightage: "18",
    },
    {
      id: 2,
      objectives: "Effective communication, Inspiration (Hunter)",
      weightage: "18",
    },
    {
      id: 3,
      objectives: "Responsibility, buck stops here (Leader)",
      weightage: "18",
    },
    {
      id: 4,
      objectives: "Reliability, Resilience (Gatherer)",
      weightage: "18",
    },
    {
      id: 5,
      objectives: "Teamwork, Mentorship (Builder)",
      weightage: "18",
    },
    {
      id: 6,
      objectives: "Wow Factor (Your Differentiator)",
      weightage: "10",
    },
  ];

  const [bdoValues, setBdoValues] = useState(
    selectedUserRecord?.period
      ? data?.softskills.map((row) => ({
        objectives: row?.objective,
        weightage: String(row.weightage),
      }))
      : BDOValues
  );

  const handleAddRowSingle = () => {
    if (upcomingData.length >= 10) {
      message.warning("You can add a maximum of 10 rows.");
      return;
    }

    const newRow = {
      key: Date.now(), // unique key
      id: upcomingData.length + 1,
      strategicObjectives: "",
      expectedOutcomes: "",
      targetDate: null,
      weightage: "",
    };

    setUpcomingData([...upcomingData, newRow]);
  };
  const jobDescriptionId =
    selectedUserRecord?.appraisalInformation[0]?.jobDescriptionId;
  const JobDescriptionFileName =
    selectedUserRecord?.appraisalInformation[0]?.jobdescriptionFileName;
  const jobdescriptionFileUrl =
    selectedUserRecord?.appraisalInformation[0]?.jobdescriptionFileUrl;

  const viewJobDescription = async () => {
    if (!jobDescriptionId || !JobDescriptionFileName) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://6oi4yhfse1.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: jobDescriptionId,
            filename: JobDescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const footerStyle = {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    background: "white",
    padding: "12px 24px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 100,
    display: "flex",
    justifyContent: "end",
    gap: "10px"
  };

  const [showResendConfirm, setShowResendConfirm] = useState(false);
  const handleDraftSubmit = async (values) => {
    try {
      if (
        weightageError ||
        weightageUpcomingError ||
        weightagePreviousError ||
        weightageStrategicError
      ) {
        return;
      }
      setLoader(true);
      let strategicInvalid = [];
      let previousInvalid = [];
      let upcomingInvalid = [];
      let bdoInvalid = [];

      strategicObjectivesData.forEach((row, idx) => {
        if (
          !row.strategicObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          strategicInvalid.push(idx);
        }
      });

      previousObjectivesData.forEach((row, idx) => {
        if (
          !row.previousObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          previousInvalid.push(idx);
        }
      });

      upcomingData.forEach((row, idx) => {
        if (
          !row.previousObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          upcomingInvalid.push(idx);
        }
      });

      bdoValues.forEach((row, idx) => {
        if (!row.weightage) {
          bdoInvalid.push(idx);
        }
      });

      setInvalidFields({
        strategic: strategicInvalid,
        previous: previousInvalid,
        upcoming: upcomingInvalid,
        bdo: bdoInvalid,
      });



      // If all validations pass, proceed with submit logic

      const payload = {
        totalappraisalinformation: data?.totalappraisalinformation,
        employeename: data.fullname,
        period: data.period,
        attendstartdate: dayjs(data.attendstartdate).format("YYYY-MM-DD"),
        attendenddate: dayjs(data.attendenddate).format("YYYY-MM-DD"),
        employeeid: data.employeeid,
        managingoffice: Array.isArray(data.managingoffice)
          ? data.managingoffice.join(", ")
          : data.managingoffice,
        grade: data.grade,
        location: data.levellocationid
          ? locationList?.find(
            (val) => val?.location_id === data?.levellocationid
          )?.location_name
          : "",
        department: data.leveldepartmentname,
        contractingcompany: data.companyname,
        appraisalinformation: data?.appraisalInformation,
        expertise: data.expertise,
        designation: data.designation,
        hireddate: data.hireddate,
        professionsince: data.professionalsince,
        apraisercreatedby: userInfo?.userid,
        apraisercreatedat: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        apraiseemailid: data.userid,
        contractstatus: "contractdraft",
        performanceid: data?.performanceid + 1,
        apraisercreatedat: "",
        createdat: "",
        personalinformation: [
          {
            salutation: data.salutation,
            dateofbirth: data.dateofbirth,
            gender: data.gender,
            maritalstatus: data.maritalstatus,
            noofdependents: data.dependent,
            greetings: data.greetings,
            phonenumber: data.phoneno,
            emailaddress: data.userid,
            postaladdress: data.postaladdress,
            emergencycontactname: data.emergencycontactname,
            emergencycontactnumber: data.emergencycontactnumber,
            emergencycontactemail: data.emergencycontactemail,
          },
        ],
        roletype: data?.appraisalInformation[0]?.roletype,
        startegicobjectives: strategicObjectivesData.map((row) => ({
          straobjorgstartegy: row.strategicObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        rolloverresponsibility: previousObjectivesData.map((row, idx) => ({
          "s.no": idx + 1,
          previousappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        upcomingappraisalperiod: upcomingData.map((row) => ({
          upcomingappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: row.weightage,
        })),
        softskills: bdoValues.map((row) => ({
          objective: row.objectives,
          weightage: Number(row.weightage),
        })),
        appraisarmailid: userInfo?.userid,
      };


      const editPayload = {
        appraiseemailid: data.userid,
        performanceid: data?.performanceid,
        period: data.period,
        attendstartdate: dayjs(data.attendstartdate).format("YYYY-MM-DD"),
        attendenddate: dayjs(data.attendenddate).format("YYYY-MM-DD"),
        apraiserupdatedby: userInfo?.userid,
        startegicobjectives: strategicObjectivesData.map((row) => ({
          straobjorgstartegy: row.strategicObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        rolloverresponsibility: previousObjectivesData.map((row, idx) => ({
          "s.no": idx + 1,
          previousappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        upcomingappraisalperiod: upcomingData.map((row) => ({
          upcomingappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: row.weightage,
        })),
        softskills: bdoValues.map((row) => ({
          objective: row.objectives,
          weightage: Number(row.weightage),
        })),
        appraisarmailid: userInfo?.userid,
        contractstatus: "contractdraft",
        draftedat: dayjs()?.format("YYYY-MM-DD"),

        // apraisercreatedat: "",
        // createdat: "",
      };


      const { code } = await CALL_API(
        selectedUserRecord?.contractstatus === "contractdraft"
          ? `appraisal/performancecontract/appraisermyteam?contractid=${Number(
            data?.contractid
          )}`
          : `appraisal/performancecontract`,
        selectedUserRecord?.contractstatus === "contractdraft" ? "patch" : "post",
        selectedUserRecord?.contractstatus === "contractdraft" ? editPayload : payload
      );
      if (code === STATUS_CODE?.SUCCESS) {
        const filterd = loadNewDataList?.filter(
          (item) => item?.userid !== selectedUserRecord?.userid
        );
        setLoadNewData(filterd);
        setIsAddEdit(false);
      }
    } catch (error) {
      console.error(error, "error in handlesubmit");
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (
        weightageError ||
        weightageUpcomingError ||
        weightagePreviousError ||
        weightageStrategicError
      ) {
        return;
      }
      setLoader(true);
      let strategicInvalid = [];
      let previousInvalid = [];
      let upcomingInvalid = [];
      let bdoInvalid = [];

      strategicObjectivesData.forEach((row, idx) => {
        if (
          !row.strategicObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          strategicInvalid.push(idx);
        }
      });

      previousObjectivesData.forEach((row, idx) => {
        if (
          !row.previousObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          previousInvalid.push(idx);
        }
      });

      upcomingData.forEach((row, idx) => {
        if (
          !row.previousObjectives ||
          !row.expectedOutcomes ||
          !row.targetDate ||
          !row.weightage
        ) {
          upcomingInvalid.push(idx);
        }
      });

      bdoValues.forEach((row, idx) => {
        if (!row.weightage) {
          bdoInvalid.push(idx);
        }
      });

      setInvalidFields({
        strategic: strategicInvalid,
        previous: previousInvalid,
        upcoming: upcomingInvalid,
        bdo: bdoInvalid,
      });

      if (
        bdoInvalid.length &&
        data?.appraisalInformation?.[0]?.roletype === "Primary"
      ) {
        message.error("Please fill all weightage fields in BDO VALUES table.");
        return;
      }

      if (strategicInvalid.length) {
        message.error("Please fill all fields in Strategic Objectives table.");
        return;
      }

      if (previousInvalid.length) {
        message.error("Please fill all fields in Previous Appraisal table.");
        return;
      }
      if (upcomingInvalid.length) {
        message.error("Please fill all fields in Upcoming Appraisal table.");
        return;
      }

      // If all validations pass, proceed with submit logic

      const payload = {
        employeename: data.fullname,
        period: data.period,
        attendstartdate: dayjs(data.attendstartdate).format("YYYY-MM-DD"),
        attendenddate: dayjs(data.attendenddate).format("YYYY-MM-DD"),
        employeeid: data.employeeid,
        managingoffice: Array.isArray(data.managingoffice)
          ? data.managingoffice.join(", ")
          : data.managingoffice,
        grade: data.grade,
        location: data.levellocationid
          ? locationList?.find(
            (val) => val?.location_id === data?.levellocationid
          )?.location_name
          : "",
        department: data.leveldepartmentname,
        contractingcompany: data.companyname,
        expertise: data.expertise,
        designation: data.designation,
        hireddate: data.hireddate,
        professionsince: data.professionalsince,
        apraisercreatedby: userInfo?.userid,
        apraisercreatedat: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        createdat: dayjs()?.format("YYYY-MM-DD"),
        apraiseemailid: data.userid,
        contractstatus: "created",
        performanceid: data?.performanceid + 1,
        personalinformation: [
          {
            salutation: data.salutation,
            dateofbirth: data.dateofbirth,
            gender: data.gender,
            maritalstatus: data.maritalstatus,
            noofdependents: data.dependent,
            greetings: data.greetings,
            phonenumber: data.phoneno,
            emailaddress: data.userid,
            postaladdress: data.postaladdress,
            emergencycontactname: data.emergencycontactname,
            emergencycontactnumber: data.emergencycontactnumber,
            emergencycontactemail: data.emergencycontactemail,
          },
        ],
        roletype: data?.appraisalInformation[0]?.roletype,
        startegicobjectives: strategicObjectivesData.map((row) => ({
          straobjorgstartegy: row.strategicObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        rolloverresponsibility: previousObjectivesData.map((row, idx) => ({
          "s.no": idx + 1,
          previousappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        upcomingappraisalperiod: upcomingData.map((row) => ({
          upcomingappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: row.weightage,
        })),
        softskills: bdoValues.map((row) => ({
          objective: row.objectives,
          weightage: Number(row.weightage),
        })),
      };

      const editPayload = {
        appraiseemailid: data.userid,
        performanceid: data?.performanceid,
        period: data.period,
        attendstartdate: dayjs(data.attendstartdate).format("YYYY-MM-DD"),
        attendenddate: dayjs(data.attendenddate).format("YYYY-MM-DD"),
        apraiserupdatedby: userInfo?.userid,
        startegicobjectives: strategicObjectivesData.map((row) => ({
          straobjorgstartegy: row.strategicObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        rolloverresponsibility: previousObjectivesData.map((row, idx) => ({
          "s.no": idx + 1,
          previousappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: Number(row.weightage),
        })),
        upcomingappraisalperiod: upcomingData.map((row) => ({
          upcomingappraisalperiod: row.previousObjectives,
          expectedoutcome: row.expectedOutcomes,
          TargetDate: row.targetDate
            ? dayjs(row.targetDate).format("YYYY-MM-DD")
            : "",
          Weightage: row.weightage,
        })),
        softskills: bdoValues.map((row) => ({
          objective: row.objectives,
          weightage: Number(row.weightage),
        })),
        contractstatus:
          selectedUserRecord?.contractstatus === "declined"
            ? "resend"
            : "updated",
      };

      const { code } = await CALL_API(
        selectedUserRecord?.period
          ? `appraisal/performancecontract/appraisermyteam?contractid=${Number(
            data?.contractid
          )}`
          : `appraisal/performancecontract`,
        selectedUserRecord?.period ? "patch" : "post",
        selectedUserRecord?.period ? editPayload : payload
      );
      if (code === STATUS_CODE?.SUCCESS) {
        const filterd = loadNewDataList?.filter(
          (item) => item?.userid !== selectedUserRecord?.userid
        );
        setLoadNewData(filterd);
        setIsAddEdit(false);
      }
    } catch (error) {
      console.error(error, "error in handlesubmit");
    } finally {
      setLoader(false);
    }
  };

  const onSubmitClick = (e) => {
    if (
      selectedUserRecord?.period &&
      selectedUserRecord?.contractstatus === "declined"
    ) {
      setShowResendConfirm(true);
    } else {
      if (submitType === "draft") {
        handleDraftSubmit()
      } else {
        handleSubmit(); // Call directly for Save/Create

      }
    }
  };

  const AppraisalFormData = {
    pages: [
      {
        modalView: false,
        colSpan: [12, 12],
        fields: [
          [
            {
              id: 1,
              label: "Name of the Employee",
              type: "text",
              name: "fullname",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 2,
              label: "Period",
              type: "select",
              name: "period",
              maxLength: 35,
              validationRules: submitType === "draft"
                ? []
                : [
                  {
                    required: true,
                    message: "Period is required",
                  },
                ],
              options: [
                "Yearly Appraisal",
                "Half Yearly Appraisal",
                "Quarterly Appraisal",
              ],
            },
          ],
          [
            {
              id: 3,
              label: "Start date to attend appraisal",
              type: "appraisal-date",
              name: "attendstartdate",
              value: data?.attendenddate,
              validationRules:
                submitType === "draft"
                  ? []
                  : [
                    {
                      required: true,
                      message: "Start date is required",
                    },
                  ],
            },
            {
              id: 4,
              label: "End date to attend appraisal",
              type: "appraisal-date",
              name: "attendenddate",
              validationRules: submitType === "draft"
                ? []
                : [
                  {
                    required: true,
                    message: "End date is required",
                  },
                ],
            },
          ],
          [
            {
              id: 5,
              label: "Employee ID",
              type: "text",
              name: "employeeid",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 6,
              label: "Managing Office",
              type: "select",
              mode: "multiple",
              name: "managingoffice",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 7,
              label: "Grade",
              type: "select",
              name: "grade",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 8,
              label: "Location",
              type: "selectwithvalue",
              name: "levellocationid",
              maxLength: 35,
              validationRules: [],
              disabled: true,
              options: locationList.map((location) => ({
                label: location.location_name,
                value: location.location_id,
              })), // Assuming locationList is an array of objects with locationname and locationid properties
            },
          ],
          [
            {
              id: 9,
              label: "Department",
              type: "select",
              mode: "multiple",
              name: "leveldepartmentname",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 10,
              label: "Contracting company",
              type: "text",
              name: "companyname",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 11,
              label: "Expertise",
              type: "text",
              name: "expertise",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 12,
              label: "Designation",
              type: "text",
              name: "designation",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 13,
              label: "Hired Date",
              type: "text",
              name: "hireddate",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 14,
              label: "Professional Since",
              type: "text",
              name: "professionalsince",
              maxLength: 35,
              disabled: true,
              validationRules: [],
            },
          ],
          [
            {
              id: 15,
              label: "Target Charge-out Rate",
              type: "text",
              name: "chargeoutrate",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 16,
              label: "Traget Chargeablity %",
              type: "text",
              name: "targetchargeability",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 17,
              label: "Last Promotion Date",
              type: "text",
              name: "lastpromotion",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 18,
              label: "Last Promotion Level",
              type: "text",
              name: "lastpromotionlevel",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 19,
              type: "component",
              content: <h6>Personal Information</h6>,
            },
          ],
          [
            {
              id: 20,
              label: "Saluation",
              type: "text",
              name: "salutation",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 21,
              label: "Date of Birth",
              type: "text",
              name: "dateofbirth",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 22,
              label: "Gender",
              type: "text",
              name: "gender",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 23,
              label: "Marital Status",
              type: "text",
              name: "maritalstatus",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 24,
              label: "No of Dependents",
              type: "text",
              name: "dependent",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 25,
              label: "Greetings",
              type: "text",
              name: "greetings",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 26,
              label: "Phone Number",
              type: "text",
              name: "phoneno",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 27,
              label: "Email Address",
              type: "text",
              name: "userid",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 28,
              label: "Postal Address",
              type: "text",
              name: "postaladdress",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 29,
              label: "Emergency Contact Name & Relationship",
              type: "text",
              name: "emergencycontactname",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 30,
              label: "Emergency Contact Number",
              type: "text",
              name: "emergencycontactnumber",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
            {
              id: 31,
              label: "Emergency Contact Email",
              type: "text",
              name: "emergencycontactemail",
              maxLength: 35,
              validationRules: [],
              disabled: true,
            },
          ],
          [
            {
              id: 37,
              type: "div",
              content: (
                <>
                  <h6>{data?.appraisalInformation?.[0]?.roletype} Role</h6>
                  <p>
                    Describe specific Strategic Objectives or other
                    developmental activities to be undertaken by Appraisee
                    during the upcoming appraisal period
                  </p>
                </>
              ),
            },
          ],
          [
            {
              id: 32,
              type: "div",
              content: (
                <>
                  <h6>Strategic objectives</h6>
                  <StyledForm>
                    <StyledTable
                      dataSource={strategicObjectivesData}
                      columns={columns}
                      className="small_table mb-3"
                      rowKey="key"
                      pagination={false}
                      footer={() => (
                        <div>
                          <Button type="dashed" onClick={handleAddRow}>
                            + Add Another (Max 10 rows)
                          </Button>
                        </div>
                      )}
                    />
                  </StyledForm>
                  {weightageStrategicError && (
                    <div style={{ color: "red" }}>
                      {weightageStrategicError}
                    </div>
                  )}
                </>
              ),
            },
          ],
          [
            {
              id: 33,
              type: "div",
              content: (
                <>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>Rollover Responsibility from Previous Appraisal</h6>

                    <p
                      onClick={() => viewJobDescription()}
                      style={{
                        color: "#1890ff",
                        textDecoration: "underline",
                        fontSize: "16px",
                      }}
                    >
                      Job Description
                    </p>
                  </div>

                  <StyledTable
                    dataSource={previousObjectivesData}
                    columns={previousAppraisalcolumns}
                    className="small_table mb-3"
                    rowKey="key"
                    pagination={false}
                    footer={() => (
                      <div>
                        <Button type="dashed" onClick={PreviousAppraisalAddRow}>
                          + Add Another (Max 10 rows)
                        </Button>
                      </div>
                    )}
                  />
                  {weightagePreviousError && (
                    <div style={{ color: "red" }}>{weightagePreviousError}</div>
                  )}
                </>
              ),
            },
          ],
          [
            {
              id: 34,
              type: "div",
              content: (
                <>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>
                      Objectives from JD for the Upcoming Appraisal Period
                    </h6>
                    <p
                      onClick={() => viewJobDescription()}
                      style={{
                        color: "#1890ff",
                        textDecoration: "underline",
                        fontSize: "16px",
                      }}
                    >
                      Job Description
                    </p>
                  </div>
                  <StyledTable
                    dataSource={upcomingData}
                    columns={UpcomingAppraisalcolumns}
                    className="small_table mb-3"
                    rowKey="key"
                    pagination={false}
                    footer={() => (
                      <div>
                        <Button type="dashed" onClick={handleAddRowSingle}>
                          + Add Another (Max 10 rows)
                        </Button>
                      </div>
                    )}
                  />

                  {weightageUpcomingError && (
                    <div style={{ color: "red" }}>{weightageUpcomingError}</div>
                  )}
                </>
              ),
            },
          ],
          data?.appraisalInformation?.[0]?.roletype === "Primary"
            ? [
              {
                id: 35,
                type: "div",
                content: (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>
                        {" "}
                        Individual (soft skills) Assessment / BDO VALUES
                      </h6>
                      <p
                        className="cursor-pointer "
                        style={{
                          color: "#1890ff",
                          textDecoration: "underline",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          if (isEditBdoValues) {
                            setBdoValues(BDOValues);
                          }
                          setIsEditBdoValues(!isEditBdoValues);
                        }}
                      >
                        {isEditBdoValues
                          ? "Use Default Weightage"
                          : "Edit Weightage"}
                      </p>
                    </div>
                    <StyledForm>
                      <StyledTable
                        className="w-100 mb-3"
                        dataSource={bdoValues}
                        columns={dataColumns}
                        pagination={false}
                        rowKey="id"
                      />{" "}
                    </StyledForm>
                    {weightageError && (
                      <div style={{ color: "red", marginTop: 8 }}>
                        {weightageError}
                      </div>
                    )}
                  </>
                ),
              },
            ]
            : [],
          [
            {
              id: 36,
              type: "div",
              content: (
                <>
                  <div style={footerStyle}>
                    <ButtonOutlined
                      style={{ width: "130px", height: "35px" }}
                      onClick={() => setIsAddEdit(false)}
                    >
                      Cancel
                    </ButtonOutlined>
                    <ButtonFilled
                      style={{ width: "130px", height: "35px" }}
                      loading={submitType === "draft" ?? loader}
                      onClick={() => setSubmitType("draft")}
                      htmlType="submit"
                    >
                      {" "}
                      {"Save as draft"}
                    </ButtonFilled>
                    <ButtonFilled
                      style={{ width: "130px", height: "35px" }}
                      htmlType="submit"
                      onClick={() => setSubmitType("normal")}
                      loading={loader}
                    >
                      {" "}
                      {selectedUserRecord?.contractstatus === "contractdraft"
                        ? "Create"
                        : selectedUserRecord?.period
                          ? selectedUserRecord?.contractstatus === "declined"
                            ? "Resend"
                            : "Save Changes"
                          : "Create"}

                    </ButtonFilled>
                  </div>{" "}
                </>
              ),
            },
          ],
        ],
      },
    ],
  };

  useEffect(() => {
    validateTotalWeightage(BDOValues);
  }, [isEditBdoValues]);

  useEffect(() => {
    layoutContentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Modal
        open={isPdfModalOpen}
        onCancel={() => setIsPdfModalOpen(false)}
        footer={null}
        width={1000}
        centered
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
        )}
      </Modal>
      <Modal
        open={showResendConfirm}
        onCancel={() => setShowResendConfirm(false)}
        onOk={() => {
          setShowResendConfirm(false);
          handleSubmit();
        }}
        okText="Yes,Resend"
        cancelText="No"
        centered
      >
        <p>
          On Re-sending,the status of the contract will be moved to "Waiting for
          Acceptance" for the appraisee to accept.
        </p>
        <p>Are you sure you want to resend this contract?</p>
      </Modal>
      <StyledDiv>
        <div className="Appraisal_first_tabledata">
          <span className="cursor-pointer" onClick={() => setIsAddEdit(false)}>
            Performance Management
          </span>{" "}
          <RightOutlined className="Right_outlined" />
          <span style={{ fontWeight: "400" }}>
            {" "}
            {selectedUserRecord?.contractstatus === "contractdraft" &&
              !selectedUserRecord?.period ||
              !isbreadcrum
              ? "Creating Contract"
              : "Editing Contract"}
          </span>
        </div>
      </StyledDiv>

      <div>
        <h6>
          {selectedUserRecord?.contractstatus === "contractdraft" || !selectedUserRecord?.period
            ? "Performance Contract"
            : "Editing Contract"}
        </h6>
      </div>
      <Spin spinning={loader} tip="Loading...">
        <GridBuilder
          formStructureJson={AppraisalFormData}
          initialValues={data}
          handleSelectChange={handleSelectChange}
          handleChange={handleChange}
          formSubmit={onSubmitClick}
        ></GridBuilder>
      </Spin>
      <img
        src={user}
        alt="Floating User Icon"
        style={{
          position: "fixed",
          bottom: "50px",
          right: "50px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          zIndex: 1000,
          cursor: "pointer",
        }}
        onClick={showModal}
      />
      <EmployeeInfo
        isModalVisible={isModalVisible}
        handleCancelModal={handleCancelModal}
        selectedEmployee={selectedEmployee}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  loadNewDataList: getLoadNewDataList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoadNewData: setLoadNewDataList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditPerformance);
